import React, { useState } from "react";
import { Button, Row, Space, Typography } from "antd";
import { TFunction } from "i18next";
import { IUserInfos } from "../../../helpers/types";
import { useNavigate } from "react-router-dom";
import BecomingCreatorModalComponent from "../../../components/BecomingCreatorModalComponent";

interface Props {
  user: IUserInfos;
  t: TFunction<"translation", undefined, "translation">;
}

export default function BecomeProfessional({ user, t }: Props) {

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const className = user.isProfessional ? "individual-btn professional" : "individual-btn";
  const title = user.isProfessional ? t("modify-my-information") : t("becoming-a-professional");
  const handleClick = user.isProfessional ? () => navigate("/creator/billingAddress") : () => setIsOpen(true);

  const handleSubmit = () => {
    navigate("/creator/billingAddress");
  };

  return (
    <>  
      <Row className="mt-10">
        <Space className="w-full gap-6" direction="vertical">
          <Typography.Text className="font-16-bold text-white-color">{t("account-type")}</Typography.Text>
          <div className="typeAccountRow">
            <div className="individual-div">
              <Typography.Text className="font-14-bold text-black-color">
                {user.isProfessional ? t("professional") : t("individual")}
              </Typography.Text>
            </div>
            <Button className={className} onClick={handleClick}>
              {title}
            </Button>
          </div>
        </Space>
      </Row>
      <BecomingCreatorModalComponent
        isOpen={isOpen}
        title={t("what-does-it-mean-to-become-a-professional")}
        paragraphs={[t("what-does-it-mean-to-become-a-professional-text-1"), t("what-does-it-mean-to-become-a-professional-text-2")]}
        submitText={t("confirm-btn")}
        onClose={() => setIsOpen(false)}
        onSubmit={handleSubmit}
      />
    </>
  );
}
